// export default defineNuxtPlugin(nuxtApp => {
//     const dataAll = useDataAll()
//     const { $methods } = useNuxtApp()
//     const runtimeConfig = useRuntimeConfig();
    
//      const redir = {
//           async notFound404(){
//             console.log('notFound404 called in redir301.js');

//             let redirected = false;
//            //  if ( (typeof (process) != "undefined" && process !== null) && import.meta.server ==1) {
//               const redirect = useRedirectStore();
//               console.log('redirect', redirect);
              
//               const { currentRoute } = useRouter();
//               console.log('REDIR301 -> currentRoute', currentRoute._value.fullPath);
//               // redirect found
//               // Dit controleren in de backend met oude urls
//               const newUrl = redirect.getRedirect(currentRoute._value.fullPath) || 
//                              redirect.getRedirect(currentRoute._value.fullPath.substring(1));
//               console.log('REDIR301 -> newUrl', newUrl);
//               if (newUrl) {
//                 console.log('REDIR301 -> Redirecting to:', newUrl);
//                 navigateTo(newUrl, { redirectCode: 301 });
//               }
//               else {
//                 console.log('REDIR301 -> going into else')
//                 if (runtimeConfig.public.ABORT_NAVIGATION_IMAGES_ROUTER && redir.isImageRoute(currentRoute._value.fullPath)){
//                   console.log('REDIR301 -> Image route detected, aborting navigation');
//                   navigateTo('/abortNavigation')
//                 } else {
//                   let NF = usePageOverviewStore().getPageByType("NF");
//                   console.log('REDIR301 -> No redirect found, navigating to:' + NF?.NameUrl);
//                   if (NF && NF.NameUrl){
//                     navigateTo($methods.localePath("/"+NF.NameUrl));
//                   } else {
//                     console.log('REDIR301 -> No NF page found, navigating to /404');
//                     navigateTo($methods.localePath("/404"));
//                   }
//                 }
//               }
//           //  }
//         },         
//         isImageRoute(fullPath) {
//           const supportedImageExtensions = ['.png', '.svg', '.jpg', '.jpeg', '.gif', '.webp']; // Voeg hier meer extensies toe als nodig
//           return supportedImageExtensions.some(ext => fullPath.toLowerCase().endsWith(ext));
//         },
//        isset(varIn) {
//           return (typeof (varIn) != "undefined" && varIn !== null)
//       }
//       }
//       nuxtApp.provide('redir', redir);   
// });